import { CSSProperties, MouseEvent, ReactNode, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import clsx from 'clsx';

import { MODAL_ANIMATION_DURATION } from 'shared/config/constants';

import { ALERT_VARIANT } from './types';
import { ALERT_BACKGROUNDS, ALERT_TEXT_COLOR } from './constants';
import styles from './styles.module.scss';

type AlertProps = {
  children: ReactNode;
  isVisible: boolean;
  onClose?: (e: MouseEvent) => void;
  variant?: ALERT_VARIANT;
};

export const Alert = ({
  children,
  isVisible,
  onClose,
  variant = ALERT_VARIANT.SUCCESS,
}: AlertProps) => {
  const alertRootRef = useRef<HTMLDivElement>(null);

  const alertRootStyles: CSSProperties = {
    background: ALERT_BACKGROUNDS[variant],
    color: ALERT_TEXT_COLOR[variant],
  };

  const alertCloseButtonStyles: CSSProperties = {
    color: ALERT_TEXT_COLOR[variant],
  };

  return (
    <CSSTransition
      nodeRef={alertRootRef}
      in={isVisible}
      timeout={MODAL_ANIMATION_DURATION}
      classNames="modal-fade"
      unmountOnExit
    >
      <div
        className={styles.alertRoot}
        style={alertRootStyles}
        role="alert"
        ref={alertRootRef}
      >
        <div>{children}</div>
        {onClose && (
          <button
            className={clsx('btn', 'btn-icon-ghost', styles.alertCloseButton)}
            style={alertCloseButtonStyles}
            type="button"
            aria-label="close"
            onClick={onClose}
          >
            <i className="icon-v2-close" aria-hidden />
          </button>
        )}
      </div>
    </CSSTransition>
  );
};
